<!-- * Vista de las card de promociones -->
<ion-list
  mode="ios"
  lines="none"
  id="flipcontainer"
  class="flip-container flip-vertical"
  [ngClass]="{
    flipper: detailsStatic,
    'last-card': last
  }"
>
  <!-- ? Tag Exclusivo -->
  <ng-container *ngIf="promo.Exclusivo && !promo.Sunday">
    <div class="ribbon ribbon-top-left" [id]="'ribbon-' + promo.ClavePromo">
      <span [ngStyle]="{ 'background-color': promo.Color }">
        {{ "Labels.exclusive" | translate }}
      </span>
    </div>
  </ng-container>
  <!-- ? Tag Domingo -->
  <ng-container *ngIf="promo.Sunday">
    <ion-img
      [src]="'Icons.promo-of-the-day' | translate"
      class="tag-sunday"
    ></ion-img>
  </ng-container>

  <ion-card
    color="white"
    mode="md"
    class="animated fadeIn fast card-promo front"
    [attr.data-test]="'Automation.btn-promocard-front' | translate"
  >
    <ion-card-header
      color="white"
      mode="md"
      class="card-header-img"
      [ngStyle]="{
        'border-top': '5px solid',
        'border-color': promo.Sunday
          ? promo.Color
          : 'var(--ion-color-' + (promo.TipoPromocion | typePromoColor) + ')',
        opacity: detailsStatic ? 0 : 1
      }"
    >
      <!-- ? Tag Promo -->
      <div
        class="tag-promo"
        [ngStyle]="{
          'background-image':
            'url(./assets/icon/tag-' +
            ((promo.Sunday ? 'SUNDAY' : promo.TipoPromocion) | typePromoColor) +
            '.svg)'
        }"
      >
        <ion-icon
          [src]="
            'Icons.' + (promo.Bonificacion ? 'bonus-white' : 'promotions-white')
              | translate
          "
        ></ion-icon>
      </div>
      <!-- * Imagen de la promo -->
      <ion-list mode="ios" lines="none" class="content-img-promo">
        <!-- ! Imágen de promo -->
        <ng-container *ngIf="promo.ViewImagePromo">
          <ion-img class="img-promo" [src]="promo.imagen_url"></ion-img>

          <ion-list mode="ios" lines="none" class="content-buttons-img">
            <!-- ? Zoom -->
            <ion-button
              class="mpe-button-icon-circle ion-no-padding button-zoom"
              size="small"
              mode="ios"
              shape="round"
              color="translucidWhite"
              (click)="onZoom(promo.imagen_url)"
            >
              <ion-icon
                slot="icon-only"
                [src]="'Icons.icon-zoom' | translate"
              ></ion-icon>
            </ion-button>

            <!-- ? Detalle -->
            <ion-button
              class="mpe-button-icon-circle ion-no-padding button-zoom"
              size="small"
              mode="ios"
              shape="round"
              color="translucidWhite"
              (click)="detailsStatic = true"
            >
              <ion-icon
                slot="icon-only"
                [src]="'Icons.icon-detail' | translate"
              ></ion-icon>
            </ion-button>
          </ion-list>
        </ng-container>

        <!-- ! Grid de imágenes de promo -->
        <ng-container *ngIf="!promo.ViewImagePromo">
          <ion-grid fixed class="ion-no-padding grid-list">
            <ion-row class="row-gap ion-align-items-center">
              <ng-container
                *ngFor="let m of promo.Marcas | slice : 0 : 6; let i = index"
              >
                <ion-col
                  [size]="
                    promo.Marcas.length === 1
                      ? 12
                      : promo.Marcas.length > 1 && promo.Marcas.length < 5
                      ? 6
                      : 4
                  "
                  [ngClass]="{
                    'center-col-y': promo.Marcas.length === 3 && i === 1,
                    'center-col-x':
                      promo.Marcas.length === 5 && (i === 3 || i === 4)
                  }"
                >
                  <ion-item
                    mode="md"
                    lines="none"
                    color="white"
                    class="item-img ion-text-center"
                    [ngStyle]="{
                      height: promo.Marcas.length > 6 ? '100%' : 'auto'
                    }"
                  >
                    <ng-container *ngIf="promo.Marcas.length > 6 && i === 5">
                      <ion-label
                        mode="md"
                        color="cadet-grey"
                        class="mpe-font-weight-600 more-products"
                      >
                        ...
                      </ion-label>
                    </ng-container>

                    <ng-container *ngIf="promo.Marcas.length < 7 || i < 5">
                      <ion-thumbnail
                        class="content-img"
                        [ngClass]="{
                          'thumbnail-one': promo.Marcas.length === 1,
                          'thumbnail-2': promo.Marcas.length === 2,
                          'thumbnail-3': promo.Marcas.length === 3,
                          'thumbnail-4-6': promo.Marcas.length > 3
                        }"
                      >
                        <ion-img [src]="m.URL_Imagen" class="img-src"></ion-img>
                      </ion-thumbnail>
                    </ng-container>
                  </ion-item>
                </ion-col>
              </ng-container>

              <ion-col size="12" class="ion-no-padding ion-text-center">
                <ion-button
                  class="mpe-button-link-simple button-promotional-products"
                  [attr.data-test]="'Automation.btn-store-promocard-products' | translate"
                  size="default"
                  mode="md"
                  fill="clear"
                  color="darkblue"
                  (click)="detailsStatic = true"
                >
                  <ion-label mode="md">
                    {{
                      "Buttons.promotional-" +
                        (promo.Bonificacion ? "bonus" : "products") | translate
                    }}
                  </ion-label>
                </ion-button>
              </ion-col>
            </ion-row>
          </ion-grid>
        </ng-container>
      </ion-list>

      <ion-list mode="ios" lines="none" class="content-detail-promo">
        <!-- * Titulo de la promo -->
        <ion-item
          lines="none"
          mode="md"
          class="ion-text-start item-padding item-title-promo"
          color="transparent"
        >
          <ion-label
            mode="md"
            color="status-icon-enable"
            class="title-promo mpe-font-weight-600 mpe-ellipsis-two"
            [attr.data-test]="'Automation.txt-promocard-title' | translate"
          >
            {{ promo.Promocion }}
          </ion-label>
        </ion-item>

        <!-- * Depende de la promo, muestra el descuento o icono -->
        <ion-item
          lines="none"
          mode="md"
          class="item-padding item-discount"
          color="transparent"
        >
          <app-promo-present [promo]="promo"></app-promo-present>
        </ion-item>

        <!-- * Botón detalle promo o agregar -->
        <ion-item
          lines="none"
          mode="md"
          class="item-padding"
          color="transparent"
        >
          <ng-container
            *ngIf="promo.TipoPromocion === 'ESTATICO'; else othersPromos"
          >
            <ng-container *ngIf="resetRange; else resetRangeFalse">
              <ion-skeleton-text
                slot="start"
                style="width: 80px; height: 30px"
              ></ion-skeleton-text>
            </ng-container>

            <ng-template #resetRangeFalse>
              <range-input
                slot="start"
                class="no-margin"
                [initial]="exchange"
                [configurations]="rangeInputEstatic"
                (comeBack)="addExchange($event)"
              ></range-input>
            </ng-template>

            <ng-container *ngIf="promosCart">
              <ion-button
               [attr.data-test]="'Automation.btn-promocard-iwant' | translate"
                #addPromo
                mode="md"
                color="tpcta"
                size="default"
                slot="end"
                class="buttons no-margin button-add"
                (click)="onAddPromoStatic()"
              >
                <ion-label mode="md">
                  {{
                    "Buttons." +
                      (promosCart.PaquetesCanjeados > 0
                        ? "upgrade"
                        : "i-love-you") | translate
                  }}
                </ion-label>
              </ion-button>
            </ng-container>
          </ng-container>

          <!-- ? DINAMICO ? ESCALERA -->
          <ng-template #othersPromos>
            <ng-container *ngIf="!iwantit; else cancelPromo">
              <ion-button
                [attr.data-test]="'Automation.btn-promocard-makepromo' | translate"
                #addPromo
                mode="md"
                color="tpcta"
                size="default"
                class="button-build-promotion buttons"
                (click)="onBuildPromo()"
              >
                <ion-label mode="md">
                  {{
                    "Buttons." +
                      (promo.Bonificacion ? "select" : "build-promotion")
                      | translate
                  }}
                </ion-label>
              </ion-button>
            </ng-container>

            <ng-template #cancelPromo>
              <ion-button
                mode="md"
                color="white"
                size="default"
                class="button-cancel buttons"
                (click)="onCancel($event)"
              >
                <ion-label mode="md" color="tpcta">
                  {{ "Buttons.cancel" | translate }}
                </ion-label>
              </ion-button>
            </ng-template>
          </ng-template>
        </ion-item>

        <!-- * Impactos y vigencia -->
        <ion-item
          lines="none"
          mode="md"
          class="item-padding item-available"
          color="transparent"
        >
          <ion-label
            mode="md"
            color="grayDemon"
            class="available-time"
            [attr.data-test]="'Automation.btn-promocard-availabletime' | translate"
            [ngClass]="{ 'just-end': promo.Bonificacion }"
          >
            <ng-container *ngIf="!promo.Bonificacion">
              <p class="ion-align-items-center">
                {{ "Labels.promotions-available" | translate : promoAvailable }}
              </p>
            </ng-container>

            <p
              class="ion-align-items-center"
              [ngClass]="{ 'ion-text-center': promo.Vigencia < 2 }"
            >
              <ion-text mode="md" *ngIf="promo.Vigencia > 1">
                {{ "Labels.ends-in-days" | translate : promo }}
              </ion-text>

              <ion-text mode="md" color="danger" *ngIf="promo.Vigencia < 2">
                {{ "Labels.ends-today" | translate }}
              </ion-text>
            </p>

            <ng-container *ngIf="promo.Bonificacion">
              <ion-img
                class="img-logo"
                [src]="
                  'Miscellaneous.program-logo.' + (Programa | async) | translate
                "
              ></ion-img>
            </ng-container>
          </ion-label>
        </ion-item>
      </ion-list>
    </ion-card-header>
  </ion-card>

  <!-- ! Lista de productos -->
  <ng-container>
    <ion-card color="white" mode="md" class="card-promo back" [attr.data-test]="'Automation.btn-promocard-back' | translate">
      <ng-container *ngIf="(isIOS && detailsStatic) || isAndroid">
        <ion-list
          mode="ios"
          lines="none"
          [ngClass]="{ 'animated fadeIn slow': isIOS }"
          [ngStyle]="{
            'border-top': '5px solid',
            'border-color': promo.Sunday
              ? promo.Color
              : 'var(--ion-color-' +
                (promo.TipoPromocion | typePromoColor) +
                ')'
          }"
        >
          <!-- ? Tag Promo -->
          <div
            class="tag-promo"
            [ngStyle]="{
              'background-image':
                'url(./assets/icon/tag-' +
                ((promo.Sunday ? 'SUNDAY' : promo.TipoPromocion)
                  | typePromoColor) +
                '.svg)'
            }"
          >
            <ion-icon
              [src]="
                'Icons.' +
                  (promo.Bonificacion ? 'bonus-white' : 'promotions-white')
                  | translate
              "
            ></ion-icon>
          </div>

          <!-- * Cerrar Detalle estatico -->
          <ion-item
            lines="none"
            mode="md"
            color="white"
            class="item-padding item-header-detail"
          >
            <ion-label
              mode="md"
              color="status-icon-enable"
              class="mpe-font-weight-600 promotional-products"
            >
              {{
                "Titles.promotional-" +
                  (promo.Bonificacion ? "bonus" : "products") | translate
              }}
            </ion-label>

            <ion-button
              class="mpe-button-icon-circle ion-no-padding button-detail-static"
              size="default"
              mode="ios"
              shape="round"
              fill="clear"
              color="status-icon-enable"
              slot="end"
              (click)="detailsStatic = false"
            >
              <ion-icon
                slot="icon-only"
                color="status-icon-enable"
                name="close"
              ></ion-icon>
            </ion-button>
          </ion-item>

          <!-- * Lista de productos -->
          <ion-list
            mode="ios"
            lines="none"
            [ngClass]="{ 'list-products': this.promo.Productos }"
          >
            <ng-container *ngFor="let product of this.promo.Productos">
              <ion-item
                lines="none"
                mode="md"
                color="white"
                class="item-padding item-static-product"
              >
                <ion-img [src]="product.imagen" slot="start"></ion-img>
                <ion-label mode="md" color="status-icon-enable" class="">
                  {{ product.descripcion }}
                </ion-label>
              </ion-item>
            </ng-container>
          </ion-list>
        </ion-list>
      </ng-container>
    </ion-card>
  </ng-container>
</ion-list>
